import { render, staticRenderFns } from "./can_not_buy.vue?vue&type=template&id=67413717&scoped=true"
import script from "./can_not_buy.vue?vue&type=script&lang=js"
export * from "./can_not_buy.vue?vue&type=script&lang=js"
import style0 from "./can_not_buy.vue?vue&type=style&index=0&id=67413717&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67413717",
  null
  
)

export default component.exports